// This file serves as the Webpack entry point for the legacy Javascript application.
// The dependencies and files listed below will be compiled into appropriate JS bundles by Webpack.
//
// The supporting dependencies jQuery (including jQuery UI and jquery_ujs) and Oak are
// provided to the global namespace via the Rails asset pipeline from global_dependencies.js.

import "@hotwired/turbo-rails"
import "underscore"

import "../../../vendor/assets/javascripts/spin.min"
import "../../../vendor/assets/javascripts/mediaelement"
import "../../../vendor/assets/javascripts/js.cookie"

import "./src/_shiv.js"
import "./src/socials"

import "./src/collections/mixtape_collection"
import "./src/collections/project_search_collection"

import "./src/core/async_image"
import "./src/core/collection"
import "./src/core/event_emitter"
import "./src/core/format"
import "./src/core/model"
import "./src/core/page"
import "./src/core/resizer"
import "./src/core/scroller"
import "./src/core/spinner"

import "./src/models/mixtape"
import "./src/models/project_search"

import "./src/objects/cover_image"
import "./src/objects/hover_connect"
import "./src/objects/message"
import "./src/objects/selectable"
import "./src/objects/song"
import "./src/objects/song_version"
import "./src/objects/user"
import "./src/objects/forms/profile_form"
import "./src/views/message_center"
import "./src/views/devise/register_confirmation"

// Stimulus controllers
import "../../javascript/controllers"

Turbo.setProgressBarDelay(0)
// Prevent duplicate Turbo initialization
if (!window.turboStarted) {
  window.turboStarted = true
  Turbo.start()

}

// Used in the SessionsController for handling post-login redirects
Turbo.StreamActions.redirect = function () {
  const url = this.getAttribute("target") || this.textContent?.trim()
  if (!url) return
  Turbo.visit(url) 
}